import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TitleMedium = styled.div`
  ${typographyV2.titleMd};
`;

export const BodySmall = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const StepperWrapper = styled.div`
  ${borderRadius.r2};
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  padding: 18px;
`;
